export default __webpack_public_path__ + "static/media/blog-featured-image-nfts.6246ca5a.png";